import { FC, ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';

export const SEO_CONTENT_PORTAL_ID = 'seo-content-portal-id';

type SeoContentPortalProps = {
	children: ReactNode;
};

/**
 * Mounts seo content on the correct place in the DOM using a portal
 */
const SeoContentPortal: FC<SeoContentPortalProps> = ({ children }) => {
	const seoContentPortalElementRef = useRef(document.getElementById(SEO_CONTENT_PORTAL_ID));

	if (!seoContentPortalElementRef?.current) {
		return null;
	}

	return createPortal(children, seoContentPortalElementRef.current, 'seo-content-portal');
};

export default SeoContentPortal;
